import { JOB } from '../search/constants'

export const NON_SEARCH_PARAMETERS = [
  'jobId',
  'companyId'
]

export const DEFAULT_SEARCH_PARAMETERS = {
  type: JOB
}

export const isSearchRelatedParameter = (key) => !NON_SEARCH_PARAMETERS.includes(key)
